import { module } from 'modujs';
import { gsap } from 'gsap' ;

export default class extends module {
    constructor(m) {
        super(m);

		if(window.isMobile) {
			this.events = {
				click: {
					playButton: 'openPlayer'
				}
			}
		} else {
			this.events = {
				click: {
					inner: 'openPlayer'
				}
			}
		}

		this.id = this.el.getAttribute('data-module-fullscreen-video');
		this.$video = this.$('video')[0];

		this.$video.src = this.$video.getAttribute('data-src');
		this.$video.play();
    }

    init() {
		
		gsap.delayedCall(0.1, () => {
			if(this.$video.paused) {
				this.$video.play();
			}
		});
    }

	openPlayer(e) {
		console.log('open player');
		
		this.call('open',{
			src: this.el.getAttribute('data-video-src'),
			thumbnails: this.el.getAttribute('data-fullscreen-video-thumbnails'),
			clickedEl: this.$('inner')[0]
		},'Player');
		this.call('hide',{},'Cursor',this.id)
	}

}

